module.exports = __webpack_public_path__ + "f7b5c80e02dc2541f10d683317674f75.png";